import { IInitialState } from 'src/store/initialState';

const allListsSel = (state: IInitialState): IInitialState['lists'] =>
  state.lists;

export const listsSel = (state: IInitialState) => allListsSel(state).lists;
export const currentListSel = (state: IInitialState) =>
  allListsSel(state).currentList;
export const listsIsPendingSel = (state: any) => allListsSel(state).isPending;
export const listsIsPendingListsSel = (state: any) =>
  allListsSel(state).isPendingLists;
export const listsIsUpdatingSel = (state: any) => allListsSel(state).isUpdating;
export const listsErrorSel = (state: any) => allListsSel(state).error;
export const listsSuccessSel = (state: any) => allListsSel(state).success;
